import { useContext, useEffect, useState } from "react";
import { Table } from "react-bootstrap";
import { isEmpty } from "lodash";

import SiteTitle from "../../../utils/SiteTitle/SiteTitle";
import EmptyData from "../../../utils/EmptyData/EmptyData";
import CardLayout from "../../../utils/CardLayout/CardLayout";
import CustomModal from "../../../utils/CustomModal/CustomModal";
import Breadcrumbs from "../../../utils/Breadcrumbs/Breadcrumbs";
import ConfigAdminContext, {
  configAdminContext,
} from "../../../context/Admin/ConfigAdminContext/ConfigAdminContext";

const ConfigAdmin = ({ isModal, types = [] }) => {
  const {
    configItems,
    config,
    setConfig,
    handleGetConfigItemList,
    handleEditConfigItem,
  } = useContext(configAdminContext);

  useEffect(() => {
    handleGetConfigItemList();
  }, []);

  return (
    <>
      {!isModal && (
        <>
          <SiteTitle title="آیتم های تنظیمات" />
          <Breadcrumbs
            navs={[
              { name: "داشبورد", url: "/Admin/Dashboard", type: "l" },
              { name: "آیتم های تنظیمات", type: "a" },
            ]}
            title="لیست آیتم های تنظیمات"
          />
        </>
      )}

      <CardLayout>
        {isEmpty(configItems) ? (
          <EmptyData />
        ) : (
          <Table responsive hover borderless striped>
            <thead className="thead-dark">
              <tr>
                <th>کلید</th>
                <th>توضیحات</th>
                <th>مقدار</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {configItems
                ?.filter((_c) =>
                  !isEmpty(types) ? types.includes(_c.key) : true
                )
                ?.map((_item) => (
                  <tr key={_item.key}>
                    <td>{_item.key}</td>
                    <td>{_item.description}</td>
                    <td>
                      <div
                        style={{
                          maxWidth: 300,
                          textOverflow: "ellipsis",
                          overflow: "hidden",
                        }}
                      >
                        {typeof _item.value === "boolean" ? (
                          <i
                            className={`fa fa-${
                              _item.value ? "check" : "times"
                            }`}
                          />
                        ) : (
                          _item.value
                        )}
                      </div>
                    </td>
                    <td className="mw-25">
                      {/* <button
                    onClick={() => handleShowDetailsModal(_item)}
                    className="btn btn-info mr-2"
                  >
                    جزئیات
                  </button> */}
                      <button
                        onClick={() => setConfig(_item)}
                        className="btn btn-primary mr-2"
                      >
                        جزئیات و ویرایش
                      </button>
                    </td>
                  </tr>
                ))}
            </tbody>
          </Table>
        )}
      </CardLayout>

      {/* Start Create Modal */}
      <CustomModal
        title="ویرایش آیتم تنظیمات"
        show={!isEmpty(config)}
        onHide={() => setConfig({})}
        size="lg"
      >
        <form onSubmit={handleEditConfigItem} autoComplete="off">
          <div className="row">
            <div className="col-12 mb-2">
              <label htmlFor="key">کلید</label>
              <input
                type="text"
                id="key"
                name="key"
                className="form-control"
                value={config.key}
                disabled
              />
            </div>
            <div className="col-12 mb-2">
              <label htmlFor="description">توضیحات</label>
              <input
                type="text"
                id="description"
                name="description"
                className="form-control"
                value={config.description}
                disabled
              />
            </div>
            <div className="col-12 mb-2">
              <label htmlFor="value">مقدار</label>{" "}
              {typeof config.value === "boolean" ? (
                <div className="custom-control custom-switch mb-2">
                  <input
                    type="checkbox"
                    className="custom-control-input"
                    name="value"
                    id="value"
                    defaultChecked={config.value}
                  />
                  <label className="custom-control-label" for="value">
                    فعال
                  </label>
                </div>
              ) : (
                <textarea
                  id="value"
                  name="value"
                  className="form-control"
                  defaultValue={config.value}
                  rows={10}
                />
              )}
            </div>
          </div>
          <hr />
          <button className="btn btn-primary btn-block" type="submit">
            <i className="fas fa-check mr-2" /> ویرایش
          </button>
        </form>
      </CustomModal>
      {/* End Create Modal */}
    </>
  );
};

export default ConfigAdmin;

export const ConfigModal = ({ title, configTypes }) => {
  const [isShowModal, setIsShowModal] = useState(false);

  return (
    <>
      <button
        className="btn btn-primary"
        onClick={() => setIsShowModal(!isShowModal)}
      >
        <i className="fa fa-cog mr-2" />
        تنظیمات
      </button>

      <CustomModal
        title={title}
        show={isShowModal}
        onHide={() => setIsShowModal(false)}
        size="xl"
      >
        <ConfigAdminContext>
          <ConfigAdmin isModal types={configTypes} />
        </ConfigAdminContext>
      </CustomModal>
    </>
  );
};
